import { useEffect } from 'react'
import { useState } from 'react'

import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import ImageInput from './ImageInput'
import { ChangeEvent, FileEntryBM, Sponsor } from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  handleSubmit: (
    data: SponsorInput,
    success: () => void,
    error: () => void
  ) => void
  data?: SponsorInput
}

export type SponsorInput = Omit<Sponsor, '_id'> & { _id?: string }

const SponsorForm = ({ handleSubmit, data }: Props) => {
  const { tr } = useTr()
  const initialSponsor: SponsorInput = {
    file: null,
    name: '',
    url: '',
  }

  const [formData, setFormData] = useState(initialSponsor)
  const [loading, setLoading] = useState(false)
  const [hasChanged, setHasChanged] = useState(true)

  const handleChange = (e: ChangeEvent<string | FileEntryBM | undefined>) => {
    setHasChanged(true)
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  useEffect(() => {
    if (data) {
      // eslint-disable-next-line
      setFormData(data)
      setHasChanged(false)
    }
  }, [data])

  return (
    <div>
      <form
        onSubmit={(e) => {
          setLoading(true)
          e.preventDefault()
          handleSubmit(
            formData,
            () => {
              setFormData(initialSponsor)
              setLoading(false)
            },
            () => {
              setLoading(false)
            }
          )
        }}
      >
        <h2 className='m0 primblue mbottom1'>
          {data ? tr(TrKey.edit) : tr(TrKey.create)} {tr(TrKey.sponsor)}
        </h2>
        <Input
          required
          disabled={loading}
          label={tr(TrKey.sponsorName)}
          desc={tr(TrKey.sponsorNameDescription)}
          name='name'
          id='name'
          value={formData.name}
          placeholder={tr(TrKey.sponsorName)}
          onChange={handleChange}
        />
        <Input
          required
          disabled={loading}
          label={tr(TrKey.sponsorUrl)}
          desc={tr(TrKey.sponsorUrlDescription)}
          name='url'
          id='url'
          value={formData.url}
          placeholder={tr(TrKey.sponsorUrlPlaceholder)}
          onChange={handleChange}
        />
        <ImageInput
          desc={tr(TrKey.sponsorLogoDescription)}
          label={tr(TrKey.sponsorLogo)}
          file={formData.file}
          onChange={(f) => {
            const e = {
              target: {
                name: 'file',
                value: f,
              },
            }
            handleChange(e)
          }}
        />
        <div className='gap1 jce mtop2 flex'>
          <Button disabled={loading || !hasChanged} type='submit'>
            {loading ? tr(TrKey.saving) : tr(TrKey.save)}
          </Button>
          <Button
            danger
            disabled={loading}
            onClick={() => {
              setFormData(initialSponsor)
            }}
          >
            {tr(TrKey.cancel)}
          </Button>
        </div>
      </form>
    </div>
  )
}

export default SponsorForm
